<template>
    <section class="content">
            <box >
                <div slot="body">
                    <div class="produtos" v-for="(p, iProd) in produtos">
                        <div class="row">
                            <div class="col-md-3">
                                <h4>Nome</h4>
                                <input v-model="p.nome" type="text" class="form-control">
                                <label v-if="nome===''">*Campo Obrigatório</label>
                            </div>
                            <div class="col-md-3">
                            <h4>Imagem </h4>
                            <input type="file" :id="`file-input-${iProd}`">
                            <p id="status">Please select a file</p>
                            </div>
                            <div class="col-md-6">
                                <h4>Descrição</h4>
                                <textarea v-model="p.descricao" rows="1" cols="12" class="form-control"></textarea>
                                <label v-if="descricao===''">*Campo Obrigatório</label>
                            </div>
                        </div>
                        <div class="row" v-for="(linha, index) in p.formularioPreco">
                            <div class="col-md-3">
                                <h4>Preço</h4>
                                <input v-model="linha.preco" v-money="money" value="0" min="0" step="0.01" data-number-to-fixed="2" data-number-stepfactor="100" class="form-control currency"/>
                            </div>
                            <div class="col-md-3">
                                <h4>Categoria</h4>
                                <select class="form-control" v-model="linha.id_cardapio">
                                    <option v-for="c in categories" v-bind:value="c.id">{{c.nome}}</option>
                                </select>
                                <label v-show="linha.id_cardapio===0">*Campo Obrigatório</label>
                            </div>
                            <div class="col-md-3 adicionaPreco" v-if="index === 0">
                            <a @click="adicionaPreco(iProd)">Adicionar Preço</a>
                            </div>
                            <div class="col-md-3 adicionaPreco" v-else>
                            <a @click="removerPreco(index, iProd)"><i class="fa fa-times" aria-hidden="true"></i></a>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                          <div class="col-md-1">
                              <h4>Ativo</h4>
                              <toggle-button 
                                  v-model="p.ativo"
                                  :color="color" 
                                  :sync="true" />
                          </div>
                          <div class="col-md-3">
                              <h4>Produtos permite adicionais</h4>
                              <toggle-button 
                              v-model="p.permiteadicionais"
                              :sync="true" />
                          </div>
                          <div class="col-md-2" style="    padding: 0.7em;">
                            <a @click="removerProduto(iProd)"><i class="fa fa-times" aria-hidden="true"></i></a>
                          </div> 
                        </div>
                        <div class="row" v-show="p.permiteadicionais">
                        <div class="col-md-3">
                            <h4>Categoria adicionais</h4>
                            <select class="form-control" v-model="p.adicional">
                            <option v-for="c in categories" v-bind:value="c.id">{{c.nome}}</option>
                            </select>
                        </div>
                        </div>
                        <br>
                        <hr>
                        <br>
                    </div>
                    
                    <div class="row">
                        <div class="col-sm-12 adicionaVoo" style="text-align: center">
                            <a @click="adicionarCategoria"><i class="fa fa-plus-circle" aria-hidden="true">Adicionar Categoria</i></a>
                        </div>
                    </div>
                    <br><br>
                    <router-link class="pageLink" to="/produtos">
                            <button class="btn btn-danger" >Cancelar</button>
                    </router-link>
                    <button class="btn btn-success" @click="gravar" v-show="habilitaGravar" >
                      <i class="fa fa-check">  Gravar</i>
                    </button>
                    <button v-show="gravando" class="btn btn-success"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>

                </div>
        </box>


    </section>
</template>
<script>
import axios from 'axios'
import Box from '../Box' // importando modal
import {VMoney} from 'v-money'
import s3 from '../../../services/s3'
import { setTimeout } from 'timers';

export default {
  name: 'NovoProduto',
  directives: {money: VMoney},
  components: {
    'box': Box
  },
  data () {
    return {
      erro: false,
      categories: [],
      produtos: [{
        formularioPreco: [{
          preco: 0,
          id_cardapio: 0
        }],
        nome: '',
        descricao: '',
        preco: 0,
        imagem: '',
        ativo: true,
        permiteadicionais: false,
        adicional: null
      }],
      allCategories: [],
      gravando: false,
      money: {
        thousands: ',',
        decimal: '.',
        // prefix: 'R$ ',
        precision: 2,
      },
    }
  },
  created () {
    this.getCategories()
  },
  computed: {
    habilitaGravar () {
      if (this.nome != '' && this.descricao != '' && !this.gravando) {
        for (let i in this.formularioPreco) {
          if (this.formularioPreco[i].id_cardapio === 0) {
            return false
          }
        }
        return true
      }
      return false
    }
  },
  methods: {
    adicionaPreco(iProd) {
      this.produtos[iProd].formularioPreco.push({
        preco: 0,
        categoria: 0
      })
    },
    removerPreco (index, iProd) {
      this.produtos[iProd].formularioPreco.splice(index, 1)
    },
    removerProduto(iProd) {
      this.produtos.splice(iProd, 1)
    },
    adicionarCategoria() {
        this.produtos.push({
          formularioPreco: [{
            preco: 0,
            id_cardapio: 0
          }],
          nome: '',
          descricao: '',
          preco: 0,
          imagem: '',
          ativo: true,
          permiteadicionais: false,
          adicional: null
        })
    },
    getCategories () {
      axios.get(`${this.$store.state.api}categorias?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.categories = response.data
        // console.log(this.categories)
        //this.ajustaCategorias()
      })
    },
    ajustaCategorias () {
      for (var i = 0; i < this.allCategories.length; i++) {
        if (this.verificaFolha(this.allCategories[i].id)) {
          this.categories.push(this.allCategories[i])
        } else {
          if (this.allCategories[i].children.length > 0) {
            for (var j = 0; j < this.allCategories[i].children.length; j++) {
              if (this.verificaFolha(this.allCategories[i].children[j].id)) {
                this.categories.push(this.allCategories[i].children[j])
              }
            }
          }
        }
      }
    },
    verificaFolha (id) {
      for (var i = 0; i < this.allCategories.length; i++) {
        if (id === this.allCategories[i].pai) {
          return false
        } else {
          for (var j = 0; j < this.allCategories[i].children.length; j++) {
            if (id === this.allCategories[i].children[j].pai) {
              return false
            }
          }
        }
      }
      return true
    },
    gravar () {
      this.gravando = true
      let files = this.produtos.map((element, index) => document.getElementById(`file-input-${index}`).files[0] );
      files = files.filter(function (el) {
        return el != null && el != undefined;
      });
      console.log('files => ', files)
      if(files.length > 0 ) {
        files.forEach((file, index) => {
          var blob = file.slice(0, file.size, file.type); 
          let newFile = new File([blob], `${this.$store.state.empresa_id}_produto_${Date.now()}_${file.name}`, {type: file.type});
          s3.getSignedRequest(newFile).then(res => {
            this.produtos[index].imagem = res.url;
          }).catch(err => {
            console.log('erro => ', err);
            this.erro = true;
            alert('Erro ao salvar imagem');
          })
        });
      }

      setTimeout(() => {
        if(!this.erro) {
          this.gravarProduto();
        }
      }, files.length * 1500)
    },
    getObjEnvio (index) {
      let objRetorno = [], campos = {}
      campos.nome = this.produtos[index].nome
      campos.descricao = this.produtos[index].descricao
      campos.url_imagem = this.produtos[index].imagem
      campos.permiteadicionais = this.produtos[index].permiteadicionais
      campos.ativo = this.produtos[index].ativo
      if (this.produtos[index].adicional) campos.adicional = this.produtos[index].adicional
      campos.alteracao = this.produtos[index].alteracao
      campos.id = this.produtos[index].id_alteracao
      campos.tabelapreco = []
      for(let i in this.produtos[index].formularioPreco) {
        let tabelapreco = {}
        tabelapreco.preco = parseFloat(this.produtos[index].formularioPreco[i].preco)
        tabelapreco.categoria = this.produtos[index].formularioPreco[i].id_cardapio
        campos.tabelapreco.push(tabelapreco)
      }
      campos.empresa = this.$store.state.empresa_fb_id
      objRetorno.push(campos)
      return objRetorno
    },
    gravarProduto(){
      this.produtos.forEach((produto, index) => {
        let objRetorno = this.getObjEnvio(index)
        console.log(objRetorno)
        axios.post(this.$store.state.api+'produtos/insert', objRetorno).then(response => {
          if (!response.data.success) {
            this.erro = true
          } 
        })

        setTimeout(() => {
          if (!this.erro) {
              this.$swal({
                      position: 'top-end',
                      type: 'success',
                      title: 'Incluido com sucesso',
                      showConfirmButton: false,
                      timer: 1500
                    })   
              this.$router.push('produtos');              
            } else {
              this.$swal(
                'Ops!',
                'O produto não foi gravado.',
                'error'
              )
            }
        }, this.produtos.length * 2000)
      })
    }
  }
}
</script>
<style>
.adicionaPreco {
  margin-top: 3.5%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// InclusaoRapidaProdutos.vue?242ca484